"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-danger */
var react_1 = __importDefault(require("react"));
var sanitize_html_1 = __importDefault(require("sanitize-html"));
function ExternalLink(_a) {
    var link = _a.link, tooltipText = _a.tooltipText;
    var sanitizedTooltipText = (0, sanitize_html_1.default)(tooltipText);
    return (react_1.default.createElement("a", { href: link, target: "_blank", className: "eva-external-link", tabIndex: -1, rel: "noreferrer" },
        react_1.default.createElement("span", { className: "eva-external-link-icon eva-tooltip-container--right implioicons-open-in-tab" },
            react_1.default.createElement("span", { "data-ng-if": "$ctrl.tooltipText", className: "eva-tooltip", dangerouslySetInnerHTML: { __html: sanitizedTooltipText } }))));
}
exports.default = ExternalLink;
